import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Home, Settings, Podcasts, ContactMail, DeviceHub, Send } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import AccordionSection from './AccordionSection';
import theme from "../../theme";

const drawerWidth = 200;

const StyledListItem = styled(ListItem)`
  text-decoration: none;
  color: inherit;
`;

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 35px;
  color: inherit;
`;

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    width: drawerWidth,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      backgroundColor: theme.palette.sidebar.bg,
      color: theme.palette.sidebar.fg,
    },
  }));

const DrawerContainer = styled('div')`
  margin-top: 64px;
`;

const Sidebar = ({ open }) => {
    
      const basicItems = [
        { text: 'Locations', link: '/locations', icon: <Home /> },
        { text: 'Gateways', link: '/gateways', icon: <Podcasts /> },
        { text: 'Networks', link: '/networks', icon: <DeviceHub /> },
        { text: 'Profiles', link: '/profiles', icon: <ContactMail /> },
        { text: 'Assignments', link: '/assignments', icon: <Send /> },
        // { text: 'Settings', link: '/settings', icon: <Settings /> }
      ];


    return(
        <StyledDrawer
            variant="persistent"
            open={open}
            anchor="left"
        >
            <DrawerContainer>
                <List>
                    {/* <AccordionSection title="Plant" icon={<Home />} items={plantItems} />
                    <AccordionSection title="Forwarding" icon={<ContactMail />} items={fwdItems} /> */}

                    {basicItems.map((item, index) => (
                        <StyledListItem component={Link} to={item.link} key={index}>
                        <StyledListItemIcon>
                            {item.icon}
                        </StyledListItemIcon>
                        <ListItemText primary={item.text} />
                        </StyledListItem>
                    ))}

                </List>
            </DrawerContainer>
        </StyledDrawer>
    );
};

export default Sidebar;
